import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials({ embedded = false }) {
  return (
    <div data-testid="testimonials-page" className={embedded ? "" : "pt-16"}>
      <section className="bg-ink text-cream py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-8 text-center">
          <p className="text-terracotta text-xs tracking-[0.25em] uppercase font-semibold mb-10">
            Testimonials
          </p>

          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
              data-testid={`testimonial-${i}`}
            >
              <Quote
                className="mx-auto mb-8 text-terracotta"
                size={44}
                strokeWidth={1.5}
              />
              <blockquote className="font-display text-2xl sm:text-3xl md:text-4xl leading-snug tracking-tight text-cream">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-10">
                <p className="text-lg md:text-xl font-semibold text-cream">{t.name}</p>
                <p className="mt-3 max-w-2xl mx-auto text-sm md:text-base text-cream/60 leading-relaxed">
                  {t.credits}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>
    </div>
  );
}
